import MuiStack, { StackProps } from '@mui/material/Stack';

export const Stack = ({ children, ...props }: StackProps) => (
  <MuiStack {...props}>{children}</MuiStack>
);
